import React from 'react';

/**
 * Content-area skeleton for master–detail self-service worklists
 * (Work Pass Decisions, Termination Requests).
 *
 * Page chrome (title, subtitle, tabs) is already painted. This only scaffolds
 * the inbox + reader: stacked list cards on the left, a quiet detail pane on
 * the right. Do not use SelfServiceListSkeleton here — that pattern is for
 * Education / Work Experience / Certificates (stats + filter + card grid).
 */
const SelfServiceWorklistSkeleton = () => {
  return (
    <div
      className="grid grid-cols-1 lg:grid-cols-[minmax(0,2fr)_minmax(0,3fr)] gap-4 lg:gap-6 lg:h-full lg:min-h-0"
      role="status"
      aria-label="Loading worklist"
    >
      <div className="space-y-3">
        {[1, 2, 3, 4, 5].map((index) => (
          <div
            key={index}
            className="bg-white rounded-2xl border border-gray-200 p-4"
          >
            <div className="animate-pulse space-y-3">
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0 flex-1 space-y-2">
                  <div className="h-4 bg-gray-200 rounded w-2/3" />
                  <div className="h-3 bg-gray-200 rounded w-1/2" />
                </div>
                <div className="h-6 w-16 bg-gray-200 rounded-full flex-shrink-0" />
              </div>
              <div className="flex items-center justify-between">
                <div className="h-3 bg-gray-200 rounded w-28" />
                <div className="h-3 bg-gray-200 rounded w-16" />
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="hidden lg:flex bg-white rounded-2xl border border-gray-200 p-8 items-center justify-center">
        <div className="animate-pulse w-full max-w-xs space-y-2">
          <div className="h-4 bg-gray-200 rounded w-3/4 mx-auto" />
          <div className="h-3 bg-gray-200 rounded w-1/2 mx-auto" />
        </div>
      </div>
    </div>
  );
};

export default SelfServiceWorklistSkeleton;
